// extracted by mini-css-extract-plugin
export default {"root":"FallbackPage_root__cutbu","content":"FallbackPage_content__1kv80"};